/* Standortseite: Anzeige "Jetzt geöffnet" - Fahrrad Rachow
 *
 * Warum im Browser und nicht in Liquid:
 * Shopify liefert Seiten aus dem Cache aus. Eine in Liquid gerenderte Uhrzeit
 * wäre unter Umständen Stunden alt und würde "Jetzt geöffnet" anzeigen, wenn
 * längst zu ist.
 *
 * Warum Europe/Berlin fest verdrahtet:
 * Maßgeblich ist die Uhrzeit im Laden, nicht die des Besuchers. Wer aus einer
 * anderen Zeitzone auf die Seite kommt, soll trotzdem sehen, ob in Schwerin
 * gerade offen ist.
 */
(() => {
  'use strict';

  const ZONE = 'Europe/Berlin';

  /* Wochentag und Uhrzeit am Standort ermitteln, unabhängig vom Gerät. */
  function nowAtStore() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const get = (type) => (parts.find((p) => p.type === type) || {}).value;
    /* Reihenfolge wie in der Section: Montag = 0 */
    const order = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

    return {
      day: order[get('weekday')],
      minutes: Number(get('hour')) * 60 + Number(get('minute'))
    };
  }

  function toMinutes(value) {
    const match = /^(\d{1,2})[:.](\d{2})$/.exec(String(value).trim());
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
  }

  function formatTime(value) {
    const match = /^(\d{1,2})[:.](\d{2})$/.exec(String(value).trim());
    if (!match) return String(value);
    return match[2] === '00' ? `${Number(match[1])} Uhr` : `${match[1]}:${match[2]} Uhr`;
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-location-hub]').forEach((root) => {
      /* Bewertungsband anhalten, solange ein Finger darauf liegt. Das Pausieren
         per Maus und Tastaturfokus erledigt CSS; Touch kennt kein :hover. */
      root.querySelectorAll('[data-lp-marquee]').forEach((band) => {
        const hold = () => band.classList.add('is-held');
        const release = () => band.classList.remove('is-held');
        band.addEventListener('pointerdown', hold);
        band.addEventListener('pointerup', release);
        band.addEventListener('pointercancel', release);
        band.addEventListener('pointerleave', release);
      });

       /* Online-Terminbuchung: Cal.com wird erst geladen, wenn jemand den Knopf
         ansteuert. Das Embed-Skript wiegt mehr als der Rest dieser Seite, und
         die wenigsten Besucher buchen tatsächlich - beim Seitenaufbau hat es
         deshalb nichts verloren. */
      const bookButton = root.querySelector('[data-lp-cal]');

      if (bookButton) {
        const CAL_SRC = 'https://app.cal.com/embed/embed.js';
        const NS = 'lp-werkstatt';
        let started = false;

        /* Das offizielle Cal.com-Stub. Es legt window.Cal als Warteschlange an
           und lädt embed.js beim ersten Aufruf nach - embed.js allein definiert
           window.Cal nicht, ohne das Stub bleibt es wirkungslos. Aufrufe, die
           vor dem Laden kommen, wandern in die Warteschlange und werden danach
           abgearbeitet. Deshalb darf unten sofort "modal" gerufen werden. */
        const loadCal = () => {
          if (started) return;
          started = true;
          /* eslint-disable */
          (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); } else p(cal, ar); return; } p(cal, ar); }; })(window, CAL_SRC, 'init');
          /* eslint-enable */
          window.Cal('init', NS, { origin: 'https://app.cal.com' });
          window.Cal.ns[NS]('ui', { hideEventTypeDetails: false, layout: 'month_view' });
        };

        /* Vorladen, sobald jemand den Knopf ansteuert - dann kostet der Klick
           selbst nichts mehr. */
        ['pointerenter', 'focus', 'touchstart'].forEach((type) => {
          bookButton.addEventListener(type, loadCal, { once: true, passive: true });
        });

        bookButton.addEventListener('click', (event) => {
          event.preventDefault();
          loadCal();
          window.Cal.ns[NS]('modal', {
            calLink: bookButton.getAttribute('data-lp-cal'),
            config: { layout: 'month_view' }
          });

          /* Sicherheitsnetz: Ist nach drei Sekunden kein Dialog erschienen -
             Skript blockiert, Netz weg -, folgen wir dem Link, statt den Kunden
             vor einem toten Knopf stehen zu lassen. Geprüft wird, ob der Dialog
             überhaupt je da war: Wer ihn vorher wieder schließt, soll nicht
             nachträglich weggeschickt werden. */
          let appeared = false;
          const poll = window.setInterval(() => {
            if (document.querySelector('cal-modal-box')) {
              appeared = true;
              window.clearInterval(poll);
            }
          }, 150);
          window.setTimeout(() => {
            window.clearInterval(poll);
            if (!appeared) window.location.href = bookButton.href;
          }, 3000);
        });
      }

      const holder = root.querySelector('[data-opening-hours]');
      const badge = root.querySelector('[data-open-status]');
      if (!holder || !badge) return;

      let hours;
      try {
        hours = JSON.parse(holder.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(hours) || hours.length !== 7) return;

      const now = nowAtStore();
      if (typeof now.day !== 'number') return;

      /* Heutige Zeile in der Tabelle hervorheben. */
      const row = root.querySelector('[data-weekday="' + now.day + '"]');
      if (row) row.classList.add('is-today');

      const today = hours[now.day];
      const open = today && toMinutes(today.from) !== null && toMinutes(today.to) !== null;
      const isOpen = open && now.minutes >= toMinutes(today.from) && now.minutes < toMinutes(today.to);

      badge.hidden = false;

      if (isOpen) {
        badge.classList.add('is-open');
        badge.textContent = 'Jetzt geöffnet · bis ' + formatTime(today.to);
        return;
      }

      badge.classList.add('is-closed');

      /* Wenn heute noch geöffnet wird, das sagen - sonst den nächsten Tag suchen. */
      if (open && now.minutes < toMinutes(today.from)) {
        badge.textContent = 'Geschlossen · öffnet heute um ' + formatTime(today.from);
        return;
      }

      const labels = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
      for (let step = 1; step <= 7; step += 1) {
        const index = (now.day + step) % 7;
        const entry = hours[index];
        if (entry && toMinutes(entry.from) !== null) {
          const when = step === 1 ? 'morgen' : labels[index];
          badge.textContent = 'Geschlossen · öffnet ' + when + ' um ' + formatTime(entry.from);
          return;
        }
      }

      badge.textContent = 'Zurzeit geschlossen';
    });
  });
})();
